import {
  formatDateObjectToBrowserDate,
  formatDateObjectToBrowserTime,
  parseBrowserDateAndTimeToDate,
  diffInMinutes,
  diffInHours,
  diffInDays
} from 'utilities/date';

import notifyBeforeTypes from 'constants/notify-before-types';
import recurTypes from 'constants/recur-types';

export function storeEventTemplateValuesToFieldValue(event, setValueByIndex) {

  const address = event.location.value; //empty string as default value for physical address field

  const startDateAndTime = formatToLocalDateTime(event.formattedStartDate, event.formattedStartTime);
  const endDateAndTime = formatToLocalDateTime(event.formattedEndDate, event.formattedEndTime);

  const values = [
    startDateAndTime.date,
    startDateAndTime.time,
    endDateAndTime.date,
    endDateAndTime.time,
    event.recurType,
    event.location.type,
    address,
    'HOUR'
  ];
  const throughUser = false;

  for (let index = 0; index < values.length; index++) {

    const value = values[index];

    setValueByIndex(index, value, throughUser);

  }

}

export function calculateNotifyBeforeInSeconds(notifyBefore) {

  let secondsInOneHour = 3600;

  let notifyBeforeSeconds = secondsInOneHour;

  if (notifyBefore === notifyBeforeTypes.DAY) {

    notifyBeforeSeconds = 24 * secondsInOneHour;

  }

  if (notifyBefore === notifyBeforeTypes.WEEK) {

    notifyBeforeSeconds = 7 * 24 * secondsInOneHour;

  }

  return notifyBeforeSeconds;

}

export function formatToUTCDate(localDateString) {

  if (localDateString === '') {
    return '';
  }

  const isoString = (new Date(localDateString)).toISOString();

  const [utcDateString] = isoString.split('T');

  return utcDateString;

}

export function formatToUTCDateTime(localDateString, localTimeString) {

  const result = {
    date: '',
    time: ''
  };

  if (localDateString === '' && localTimeString === '') {
    return result;
  }

  let dateString = localDateString;

  if (localDateString === '') {
    dateString = formatDateObjectToBrowserDate(new Date());
  }

  let timeString = localTimeString;

  if (localTimeString === '') {
    timeString = formatDateObjectToBrowserTime(new Date());
  }

  const date = new Date(`${dateString} ${timeString}`);
  const isoString = date.toISOString();
  const [utcDateString, timePart] = isoString.split('T');
  const [utcTimeString] = timePart.split('.');

  if (localDateString !== '') {
    result.date = utcDateString;
  }

  result.time = utcTimeString;

  return result;

}

export function formatToLocalDate(utcDateString) {

  if (utcDateString === '') {
    return '';
  }

  const date = new Date(`${utcDateString} UTC`);

  return formatDateObjectToBrowserDate(date);

}

export function formatToLocalDateTime(utcDateString, utcTimeString) {

  const result = {
    date: '',
    time: '',
    dateTime: 0
  };

  if (utcDateString === '' && utcTimeString === '') {
    return result;
  }

  let dateString = utcDateString;

  if (utcDateString === '') {
    dateString = formatDateObjectToBrowserDate(new Date());
  }

  let timeString = utcTimeString;

  if (utcTimeString === '') {
    timeString = formatToUTCTimeString(new Date());
  }

  const date = new Date(`${dateString} ${timeString} UTC`);

  if (utcDateString !== '') {
    result.date = formatDateObjectToBrowserDate(date);
  }

  result.time = formatDateObjectToBrowserTime(date);
  result.dateTime = date.getTime();

  return result;

}

function formatToUTCTimeString(date) {

  const isoString = date.toISOString();
  const [, timePart] = isoString.split('T');
  const [utcTimeString] = timePart.split('.');

  return utcTimeString;

}

export function validateRecurType(options) {

  const dateDetails = options.dateDetails;
  const recurType = options.recurType;

  const startDateTime = parseBrowserDateAndTimeToDate(dateDetails.formattedStartDate, dateDetails.formattedStartTime);
  const endDateTime = parseBrowserDateAndTimeToDate(dateDetails.formattedEndDate, dateDetails.formattedEndTime);

  const result = {
    valid: false,
    validRecurTypes: [recurTypes.NO_REPEAT]
  };

  if (diffInMinutes(endDateTime, startDateTime) <= (24 * 60)) {

    const validRecurTypes = [
      recurTypes.NO_REPEAT,
      recurTypes.DAILY,
      recurTypes.WEEKLY,
      recurTypes.MONTHLY
    ];

    result.valid = validRecurTypes.indexOf(recurType) !== -1;
    result.validRecurTypes = validRecurTypes;

  } else if (diffInHours(endDateTime, startDateTime) <= (7 * 24)) {

    const validRecurTypes = [
      recurTypes.NO_REPEAT,
      recurTypes.WEEKLY,
      recurTypes.MONTHLY
    ];

    result.valid = validRecurTypes.indexOf(recurType) !== -1;
    result.validRecurTypes = validRecurTypes;

  } else if (diffInDays(endDateTime, startDateTime) <= (4 * 7)) {

    const validRecurTypes = [
      recurTypes.NO_REPEAT,
      recurTypes.MONTHLY
    ];

    result.valid = validRecurTypes.indexOf(recurType) !== -1;
    result.validRecurTypes = validRecurTypes;

  } else {
    result.valid = result.validRecurTypes.indexOf(recurType) !== -1;
  }

  return result;

}